module.exports = __webpack_public_path__ + "img/blis6.267cafcc.png";